import { render, staticRenderFns } from "./RoomSelectorSlot.vue?vue&type=template&id=0d864700&"
import script from "./RoomSelectorSlot.vue?vue&type=script&setup=true&lang=js&"
export * from "./RoomSelectorSlot.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports